import React, { useEffect } from 'react';

export default function useUnmount(cb) {
  useEffect(() => {
    return () => {
      cb();
    }
  }, [cb])
}